import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

const useActivityItemStyles = makeStyles()(() => ({
  container: {
    'display': 'flex',
    'flexDirection': 'row',
    'gap': theme.gap.m,
    'flexWrap': 'nowrap',
    'boxShadow': `2px 2px 5px 5px ${colors.gray['200']}`,
    'borderRadius': theme.borderRadius.s,
    'padding': theme.padding.m,
    'minWidth': '100%',
    'justifyContent': 'space-between',
    'cursor': 'pointer',
    '&:hover': {
      backgroundColor: colors.blue['100'],
    },
    '&:active': {
      backgroundColor: colors.blue['200'],
    },
  },
  text: {
    'color': theme.primary.light,
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.default,
    'fontWeight': theme.fontWeight.medium,
    'whiteSpace': 'nowrap',
    'overflow': 'hidden',
    'textOverflow': 'ellipsis',
    'flex': '2',
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
  date: {
    color: colors.gray['300'],
    flex: '1',
    maxWidth: 'fit-content',
    minWidth: 'fit-content',
  },
}));

export default useActivityItemStyles;
